import React from "react";
import {useQuery} from "@apollo/client";
import TableCustom from "../components/Table/TableCustom";
import AlertForm from "../components/AlertForm";
import {MALFUNCTIONS_QUERY} from "../queries/BrokenElevators";
import TableAlerts from "../components/Table/TableAlerts";

const BrokenElevators = () => {

    const { loading, error, data } = useQuery(MALFUNCTIONS_QUERY);

    if (loading) {
        return <div>Loading...</div>;
    }

    if (error) {
        return <div>Error occurred. {error.message}</div>;
    }

    return (
        <div style={{display: 'flex', flexDirection: 'column', margin: "2%"}}>
            <div style={{margin: '1%'}}>
                <h4>
                    Active Malfunctions
                </h4>
                <div>
                    <AlertForm />
                </div>
            </div>
            <div style={{margin: '1%'}}>
                <h4>
                    Alerts
                </h4>
                <div>
                    <TableAlerts data={data.Alerts} rowsPerPage={5} />
                </div>
            </div>
        </div>
    );
}

export default BrokenElevators;